import initialConfig from "./initialConfig";

const storeInitializer = store => {
    try {
      // console.log('StoreInitializer...', store);
      initialConfig(store);
    }
    catch(error) {
      console.error('<<- STORE INIT ERROR ->>', error.message);
      throw error;
    }
  }
  
  export default storeInitializer;